module.exports = __webpack_public_path__ + "static/media/10_CALCINHA_DRAPEADA_LARGA_LISA_04.b11f7880.jpg";